import { BaseElement } from "../../lib/base-element.js";
import offerBoxStyles from "../../lib/offer-box-styles.js";
import { css, html } from "lit";
import { property, query, customElement } from "lit/decorators.js";
import "../season-interruption/season-interruption.js";
import "../gap-medical/gap-medical.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let CombinationOfferOption = class extends BaseElement {
  constructor() {
    super(...arguments);
    this.customerCountry = "US";
  }
  firstUpdated() {
    for (const [k, v] of Object.entries(this.dataset)) {
      this._seasonInterruptionRef.setAttribute(`data-${k}`, v);
      this._gapMedicalRef.setAttribute(`data-${k}`, v);
    }
  }
  render() {
    return html`
      <season-interruption 
        .clientId=${this.clientId} 
        .offerId=${this._offerId}
        .customerFirstName=${this.customerFirstName}
        .customerLastName=${this.customerLastName}
        .customerEmailAddress=${this.customerEmailAddress}
        .customerCity=${this.customerCity}
        .customerState=${this.customerState}
        .customerStreetAddress=${this.customerStreetAddress}
        .customerPostalCode=${this.customerPostalCode}
        .customerCountry=${this.customerCountry}
        .eventStartDate=${this.eventStartDate}
        .eventEndDate=${this.eventEndDate}
        .insurableAmount=${this.insurableAmount}
        .participantFirstName=${this.participantFirstName}
        .participantLastName=${this.participantLastName}
        data-unique-id=${this.dataset.uniqueId}
      ></season-interruption>
      <gap-medical
        .clientId=${this.clientId} 
        .offerId=${this._offerId}
        .customerFirstName=${this.customerFirstName}
        .customerLastName=${this.customerLastName}
        .customerEmailAddress=${this.customerEmailAddress}
        .customerCity=${this.customerCity}
        .customerState=${this.customerState}
        .customerStreetAddress=${this.customerStreetAddress}
        .customerPostalCode=${this.customerPostalCode}
        .customerCountry=${this.customerCountry}
        .coverageStartDate=${this.eventStartDate}
        .coverageEndDate=${this.eventEndDate}
        .coverageType=${this.activity}
        .participantFirstName=${this.participantFirstName}
        .participantLastName=${this.participantLastName}
        .participantBirthDate=${this.participantBirthDate}
        .participantState=${this.participantState}
        .participantStreetAddress=${this.participantStreetAddress}
        data-unique-id=${this.dataset.uniqueId}
      ></gap-medical>
    `;
  }
};
CombinationOfferOption.styles = [
  offerBoxStyles,
  css`
      :host {
        display: none;
      }
    `
];
__decorateClass([
  property()
], CombinationOfferOption.prototype, "customerFirstName", 2);
__decorateClass([
  property()
], CombinationOfferOption.prototype, "customerLastName", 2);
__decorateClass([
  property()
], CombinationOfferOption.prototype, "customerEmailAddress", 2);
__decorateClass([
  property()
], CombinationOfferOption.prototype, "customerStreetAddress", 2);
__decorateClass([
  property()
], CombinationOfferOption.prototype, "customerState", 2);
__decorateClass([
  property()
], CombinationOfferOption.prototype, "customerCity", 2);
__decorateClass([
  property()
], CombinationOfferOption.prototype, "customerPostalCode", 2);
__decorateClass([
  property()
], CombinationOfferOption.prototype, "customerCountry", 2);
__decorateClass([
  property({ attribute: "event-start-date" })
], CombinationOfferOption.prototype, "eventStartDate", 2);
__decorateClass([
  property({ attribute: "event-end-date" })
], CombinationOfferOption.prototype, "eventEndDate", 2);
__decorateClass([
  property({ type: Number, attribute: "insurable-amount" })
], CombinationOfferOption.prototype, "insurableAmount", 2);
__decorateClass([
  property({ type: String, attribute: "activity" })
], CombinationOfferOption.prototype, "activity", 2);
__decorateClass([
  property({ attribute: "participant-first-name" })
], CombinationOfferOption.prototype, "participantFirstName", 2);
__decorateClass([
  property({ attribute: "participant-last-name" })
], CombinationOfferOption.prototype, "participantLastName", 2);
__decorateClass([
  property({ attribute: "participant-street-address" })
], CombinationOfferOption.prototype, "participantStreetAddress", 2);
__decorateClass([
  property({ attribute: "participant-state" })
], CombinationOfferOption.prototype, "participantState", 2);
__decorateClass([
  property({ attribute: "participant-birth-date" })
], CombinationOfferOption.prototype, "participantBirthDate", 2);
__decorateClass([
  property({ attribute: "coverage-context-description" })
], CombinationOfferOption.prototype, "coverageContextDescription", 2);
__decorateClass([
  query("season-interruption")
], CombinationOfferOption.prototype, "_seasonInterruptionElement", 2);
__decorateClass([
  query("gap-medical")
], CombinationOfferOption.prototype, "_gapMedicalElement", 2);
__decorateClass([
  property({ attribute: false })
], CombinationOfferOption.prototype, "_offerId", 2);
__decorateClass([
  query("season-interruption")
], CombinationOfferOption.prototype, "_seasonInterruptionRef", 2);
__decorateClass([
  query("gap-medical")
], CombinationOfferOption.prototype, "_gapMedicalRef", 2);
CombinationOfferOption = __decorateClass([
  customElement("combination-offer-option")
], CombinationOfferOption);
export {
  CombinationOfferOption
};
